import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

type FAQItem = {
  question: string;
  answer: string;
};

type FAQProps = {
  faqItems: FAQItem[];
};

export const FAQ = ({ faqItems }: FAQProps) => {
  return (
    <section className="dark:bg-gray-900 bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <div className="mb-4 flex justify-center">
            <HelpCircle className="h-12 w-12 text-primary" />
          </div>
          <h2 className="mb-4 text-3xl font-thin sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="mx-auto max-w-2xl dark:text-gray-300 text-gray-600 text-lg">
            Got questions? I've got answers! Here are some of the most common questions about working with me.
          </p>
        </div>
        
        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="dark:border-gray-800 border-gray-200">
                <AccordionTrigger className="text-left text-lg font-medium hover:text-primary">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="dark:text-gray-300 text-gray-600">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};